import { data } from "./data";

export default function GifShowcase() {
    return (
        <section id="home" className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute top-1/4 right-0 w-72 h-72 bg-[#cd41ff]/10 rounded-full blur-[80px]"></div>
      <div className="absolute bottom-1/4 left-0 w-72 h-72 bg-purple-600/10 rounded-full blur-[80px]"></div>
            
            <div className="max-w-4xl mx-auto text-center relative z-10">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-[#cd41ff] to-purple-400 bg-clip-text text-transparent">
                    {data.gifShowcaseData.gifShowcaseTitle}
                </h2>
                
                <div className="h-1 w-20 bg-gradient-to-r from-[#cd41ff] to-purple-500 rounded mx-auto mb-6"></div>
                
                <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                    {data.gifShowcaseData.gifShowcaseDescription}
                </p>
                
          <div className="relative mx-auto rounded-xl overflow-hidden shadow-2xl border border-gray-800/50 hover:border-[#cd41ff]/30 transition-all group max-w-3xl">
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-gradient-to-r from-[#cd41ff]/20 to-purple-600/20 blur-sm"></div>
          <video 
            src={data.gifShowcaseData.gifPath} 
            autoPlay 
            loop 
            muted 
            playsInline
            className="relative z-10 w-full h-auto rounded-xl"
          />
                </div>
                
                <div className="mt-8">
                    <a 
                        href="https://discord.gg/9RJDwDebmx" 
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-[#cd41ff] to-purple-600 text-white font-semibold shadow-lg hover:shadow-[#cd41ff]/20 hover:shadow-xl transition-all"
                    >
                        {data.gifShowcaseData.joinCommunityButtonText}
                    </a>
                </div>
            </div>
        </section>
    );
}
